import { applySvgLayerNames } from './svgLayerNames'
import { getSvgMetrics } from './brandTheme/svgMetrics'
import { CHART_IDS } from '../charts/chartIds'
import { getBumpLegendOrder } from './legendLayout'
import { applySvgTransformPipeline } from './svgTransformPipeline'


function hasMappedRank(mapping = {}) {
  const ids = mapping?.rank?.ids
  if (Array.isArray(ids)) {
    return ids.length > 0
  }

  const value = mapping?.rank?.value
  if (Array.isArray(value)) {
    return value.length > 0
  }

  return Boolean(value)
}

export function buildExportSvg(rawViz, brandTheme, context = {}) {
  if (!rawViz?._node?.firstChild) return null

  const sourceSvgNode = rawViz._node.firstChild
  const svgNode = sourceSvgNode.cloneNode(true)

  // cloneNode() doesn't copy JS properties; D3 stores tick values as __data__ on
  // each .tick element. Copy them so applyAxisDisplayFormatsToSvg can format dates/numbers.
  const sourceTicks = Array.from(sourceSvgNode.querySelectorAll('.tick'))
  const clonedTicks = Array.from(svgNode.querySelectorAll('.tick'))
  sourceTicks.forEach((src, i) => {
    if (clonedTicks[i] && src.__data__ != null) {
      clonedTicks[i].__data__ = src.__data__
    }
  })

  const legendOrder =
    context.legendOrder ||
    (context.chartId === CHART_IDS.BUMP_CHART && hasMappedRank(context.mapping)
      ? getBumpLegendOrder(rawViz?._mappedData, context.mapping)
      : null)

  // Attach to DOM so getBBox() returns real measurements throughout all transforms.
  // Without this, the rawViz mount node has already been removed from the DOM and
  // every getBBox() call returns 0 — causing clipped viewBoxes and missed label cleanup.
  const tempHost = document.createElement('div')
  tempHost.setAttribute('aria-hidden', 'true')
  tempHost.style.cssText =
    'position:absolute;left:-100000px;top:0;visibility:hidden;pointer-events:none'
  document.body.appendChild(tempHost)
  tempHost.appendChild(svgNode)

  try {
    const sourceMetrics = getSvgMetrics(svgNode)
    applySvgTransformPipeline(svgNode, {
      brandTheme,
      svgMetrics: sourceMetrics,
      chartId: context.chartId,
      mapping: context.mapping,
      dataTypes: context.dataTypes,
      visualOptions: context.visualOptions,
      recolorMarks: context.recolorMarks !== false,
      legendOrder,
    })
  } finally {
    tempHost.removeChild(svgNode)
    document.body.removeChild(tempHost)
  }

  applySvgLayerNames(svgNode)
  return svgNode
}

export function getCanvasSize(svgNode) {
  if (!svgNode) {
    return { width: 1200, height: 800 }
  }

  const viewBox = svgNode.getAttribute('viewBox')
  if (viewBox) {
    const [, , width, height] = viewBox.split(/\s+/).map(Number.parseFloat)
    if (Number.isFinite(width) && Number.isFinite(height)) {
      return { width, height }
    }
  }

  return {
    width:
      svgNode.clientWidth || Number.parseFloat(svgNode.getAttribute('width')) || 1200,
    height:
      svgNode.clientHeight ||
      Number.parseFloat(svgNode.getAttribute('height')) ||
      800,
  }
}
